import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  TableContainer,
  Chip,
  Pagination,
  Select,
  MenuItem,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Snackbar,
  Alert,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { useState, useContext } from "react";
import { styled } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import AddIcon from "@mui/icons-material/Add";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import SearchIcon from "@mui/icons-material/Search";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ScheduleIcon from "@mui/icons-material/Schedule";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Description } from "@mui/icons-material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";
import { TextField, InputAdornment } from "@mui/material";
import AccordianDetails from "./AccordianDetails";
import UserContext from "../../context/user";
import Link from "@mui/material/Link";
import Api from "../../service/api";
import CONSTANT from "../../Constant/Constant";
import NotFoundPopup from "./NotFoundPopup";
import { useHistory } from "react-router-dom";
import CONFIG from "../../config";
import writeExcelFile from "write-excel-file/browser";
import InfoIcon from "@mui/icons-material/Info";
import {
  EXPIRE_TIME_UPLOAD_HISTORY_VIEW_FILE_RESULT,
  EXPIRE_TIME_UPLOAD_HISTORY_DOWNLOAD,
} from "../../Constant/BulkOpsContant";

const ResultsTable = ({
  tableData,
  headers,
  filters,
  sortableColumns = [],
  handleDownload,
  tableType,
  fetchMoreRecords = () => {},
  cursor = null,
  continuePolling,
}) => {
  const [statusFilter, setStatusFilter] = useState("All");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [expandedRow, setExpandedRow] = useState(null);
  const [userProfile, setUserProfile] = useState(false);
  const [entityId, setEntityId] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(true);
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    errorMessage: "",
  });
  const [dcrDialog, setDcrDialog] = useState({ open: false, dcrs: [] });
  const [downloadingHistoryId, setDownloadingHistoryId] = useState(null);
  const [checkingProfileId, setCheckingProfileId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const searchType = sessionStorage.getItem("searchType");
  const serachIn = sessionStorage.getItem("searchIn");
  const UserInfo = useContext(UserContext);

  const history = useHistory();

  const handleViewDetails = (rowKey) => {
    setExpandedRow(expandedRow === rowKey ? null : rowKey);
  };
  const createEPHLink = (entityId) => {
    if (entityId === "-" || !entityId) return null;
    return process.env.REACT_APP_STAGE === "prod"
      ? `https://361.reltio.com/nui/N6QdWQ05wkTZjLA/profile?entityUri=entities%2F${entityId}`
      : `https://test.reltio.com/nui/mNNfGtHg2wVTZ1B/profile?entityUri=entities%2F${entityId}`;
  };

  // Create a mapping from headers to actual data keys
  const getDataKeyFromHeader = (header) => {
    if (tableData.length === 0) return null;

    // Get all keys from the first data item
    const dataKeys = Object.keys(tableData[0]);

    // Try to find a matching key (case-insensitive comparison)
    const headerLower = header.toLowerCase().replace(/\s+/g, "");
    const matchingKey = dataKeys.find(
      (key) => key.toLowerCase() === headerLower,
    );

    return matchingKey || null;
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let lastPage = newPage + 1 === Math.ceil(tableData.length / rowsPerPage);
    if (tableType === "upload-history" && lastPage && cursor) {
      fetchMoreRecords();
    }
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when page size changes
  };

  // Handle status filter change
  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0); // Reset to first page when filter changes
  };

  // Handle search query change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to first page when search changes
  };

  // Handle sorting (cycles through: null -> asc -> desc -> null)
  const handleSort = (dataKey) => {
    // Only sort if we have a valid data key
    if (!dataKey) return;

    // Cycle through sort states: unsorted -> asc -> desc -> unsorted
    if (sortConfig.key !== dataKey) {
      // New column, start with ascending
      setSortConfig({ key: dataKey, direction: "asc" });
    } else if (sortConfig.direction === "asc") {
      // Already ascending, change to descending
      setSortConfig({ key: dataKey, direction: "desc" });
    } else {
      // Already descending, remove sort (back to original)
      setSortConfig({ key: null, direction: null });
    }
  };

  // Sort data based on sortConfig
  const sortData = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === "string" && typeof bValue === "string") {
        const comparison = aValue.localeCompare(bValue);
        return sortConfig.direction === "asc" ? comparison : -comparison;
      }

      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  const CustomButton = styled(Button)(({ theme }) => ({
    borderColor: "#D31710",
    color: "#D31710",
    "&:hover": {
      backgroundColor: "#FBF5F4",
      borderColor: "#B01309",
      color: "#B01309",
    },
    "&:disabled": {
      backgroundColor: theme.palette.grey[300],
      borderColor: theme.palette.grey[300],
      color: theme.palette.grey[500],
    },
  }));

  const handleClickHistory = (
    scope,
    uploadid,
    appid,
    totalRecordsCount,
    searchType,
    createdAt,
    eConsentCountry,
    resultStatus,
  ) => {
    if (createdAt) {
      const createdDate = new Date(createdAt);
      const currentDate = new Date();
      const diffTime = Math.abs(currentDate - createdDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > EXPIRE_TIME_UPLOAD_HISTORY_VIEW_FILE_RESULT) {
        setSnackbar({
          open: true,
          message: "This record is older than 60 days and cannot be accessed.",
          severity: "warning",
        });
        return;
      }
    }

    if (appid === "BULKSEARCH") {
      sessionStorage.setItem("searchUploadId", uploadid);
      sessionStorage.setItem("searchIn", scope);
      sessionStorage.setItem("totalCsvRows", parseInt(totalRecordsCount));
      sessionStorage.setItem("searchType", searchType);
      history.push(`/bulk-search/results`);
    }
    if (appid === "BULKUPLOAD") {
      sessionStorage.setItem("uploadId", uploadid);
      sessionStorage.setItem("totalRowUploaded", parseInt(totalRecordsCount));
      sessionStorage.setItem("userSelectedCountry", eConsentCountry);

      if (resultStatus === "REVIEW_PENDING" || resultStatus === "PENDING") {
        history.push(`/bulk-upload/search-results`);
      } else {
        history.push(`/bulk-upload/results`);
      }
    }
  };

  const handleCheckProfile = (result) => {
    setCheckingProfileId(result.EntityId);
    Api.getUserDetails(result.EntityId, result.type, CONSTANT.COMMERCIAL_USER)
      .then((response) => {
        if (response.status === 200) {
          window.open(`/details/${result.EntityId}/${result.type}`, "_blank");
        } else {
          setEntityId(result.EntityId);
          setUserProfile(true);
        }
      })
      .catch((error) => {
        setEntityId(result.EntityId);
        setUserProfile(true);
      })
      .finally(() => {
        setCheckingProfileId(null);
      });
  };

  const getAllDCRLinks = (result) => {
    let baseAppUrl = CONFIG.MSAL_REDIRECT_URI;
    const env = process.env.REACT_APP_STAGE;
    if (env === "dev_2") baseAppUrl = "https://ecs-dev.lilly.com";
    if (Array.isArray(result.results)) {
      return result.results
        .map((dcr) => {
          let link = null;
          switch (dcr?.vendor) {
            case "IQVIA_US":
            case "IQVIA":
              link = `${baseAppUrl}/track-iqviaDetail/${dcr?.change_request_id}`;
              break;
            case "VNDR-VN":
              link = `${baseAppUrl}/track-vnDetail/${dcr?.change_request_id}`;
              break;
            case "VNDR-VOD":
              link = `${baseAppUrl}/view-all/requests/${dcr?.change_request_id}/OPEN-DATA`;
              break;
            case "Lilly":
              link = `${baseAppUrl}/view-all/requests/${dcr?.change_request_id}/Lilly`;
              break;
            case "EPH":
              link = `${baseAppUrl}/view-all/requests/${dcr?.change_request_id}/Lilly`;
              break;
            default:
              link = null;
          }
          return {
            id: dcr?.change_request_id,
            vendor: dcr?.vendor,
            link: link,
          };
        })
        .filter((dcr) => dcr.link !== null);
    }
    return [];
  };

  const getEntityId = (result) => {
    const hasVendorKey =
      Array.isArray(result.results) &&
      result.results.length > 0 &&
      "vendor" in result.results[0];
    const getShellProfileEntityId = (shellProfileResults, entityType) => {
      if (!shellProfileResults) return null;

      if (entityType?.toLowerCase() === "hcp") {
        return (
          shellProfileResults.HcpEntityId || shellProfileResults.HCPEntityId
        );
      } else {
        return (
          shellProfileResults.HcoEntityId || shellProfileResults.HCOEntityId
        );
      }
    };

    const getRegularEntityId = (results, entityType) => {
      if (!results || typeof results !== "object" || Array.isArray(results)) {
        return null;
      }

      if (entityType?.toLowerCase() === "hcp") {
        return (
          results.StandaloneHCPEntityId ||
          results.HcpEntityId ||
          results.HCPEntityId
        );
      } else {
        return (
          results.StandaloneHCOEntityId ||
          results.HcoEntityId ||
          results.HCOEntityId
        );
      }
    };
    if (
      result.operationType === "CREATE" &&
      hasVendorKey &&
      result?.hasShellProfile
    ) {
      if (result.shellProfileResultStatus === true) {
        const entityId = getShellProfileEntityId(
          result.shellProfileResults,
          result.entityType,
        );
        if (entityId) return entityId;
      }
    }

    if (
      result.operationType === "CREATE" ||
      result.operationType === "UPDATE"
    ) {
      const entityId = getRegularEntityId(result.results, result.entityType);
      if (entityId) return entityId;
    }
    return "-";
  };
  const handleDownloadHistory = async (
    uploadId,
    appId,
    createdAt,
    searchType,
    fileName,
  ) => {
    if (createdAt) {
      const createdDate = new Date(createdAt);
      const currentDate = new Date();
      const diffTime = Math.abs(currentDate - createdDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > EXPIRE_TIME_UPLOAD_HISTORY_DOWNLOAD) {
        setSnackbar({
          open: true,
          message: "This record is older than 60 days and cannot be download.",
          severity: "warning",
        });
        return;
      }
    }
    if (downloadingHistoryId !== null) {
      setSnackbar({
        open: true,
        message: "Already another file is processing, please wait...",
        severity: "warning",
      });
      return;
    }

    try {
      setDownloadingHistoryId(uploadId);
      setSnackbar({
        open: true,
        message: "Please wait, your file is being prepared for download...",
        severity: "info",
      });

      let cursor = null;
      const allData = [];

      do {
        const response = await Api.bulkHistoryDownload(
          appId,
          cursor,
          uploadId,
          createdAt,
        );

        if (response.status === 200 && response.data) {
          allData.push(response.data);
          cursor = response.data.cursor;
          if (cursor) {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        } else {
          cursor = null; // Stop polling on error or empty response
        }
      } while (cursor);

      if (allData.length > 0) {
        // New streaming approach for large files
        const createBlobFromChunks = (chunks) => {
          const byteArrays = [];
          for (const chunk of chunks) {
            if (chunk.data) {
              try {
                const binaryString = atob(chunk.data);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) {
                  bytes[i] = binaryString.charCodeAt(i);
                }
                byteArrays.push(bytes);
              } catch (e) {
                console.warn("Failed to decode a base64 chunk:", e);
              }
            }
          }
          return new Blob(byteArrays);
        };

        const blob = createBlobFromChunks(allData);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;

        // Determine file extension
        const firstChunk = allData[0]?.data || "";
        let fileExtension = ".csv"; // Default to CSV
        try {
          const binaryString = atob(firstChunk.substring(0, 100));
          if (binaryString.startsWith("PK")) {
            fileExtension = ".xlsx";
          }
        } catch (e) {
          // Ignore decoding errors for file type detection
        }

        const randomNumber = Math.floor(Math.random() * 10000);
        // a.download = `${appId}_${randomNumber}${fileExtension}`;
        a.download = `${fileName}${fileExtension}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // Show success message
        setSnackbar({
          open: true,
          message: "File downloaded successfully!",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "No data available for download.",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: `Download failed: ${error.message}`,
        severity: "error",
      });
    } finally {
      setDownloadingHistoryId(null);
    }
  };

  const exportToExcel = async () => {
    // Convert results to Excel format
    const filteredHeaders = headers.filter(
      (header) => header.toLowerCase() !== "actions",
    );
    const formatErrorMessage = (errorMessage) => {
      if (!errorMessage) return "-";
      return errorMessage.replace(/\n+/g, ". ").trim();
    };

    // Define headers based on table type
    const excelHeaders =
      tableType === "bulk-search"
        ? [
            searchType === "basic" &&
              serachIn === "eph" &&
              "Input Enterprise Id",
            serachIn === "vendor" ? "One Key ID" : "Enterprise ID",
            "Entity ID",
            "Country Code",
            "Classification Code",
            "Name",
            "Primary Specialty",
            "Primary Address",
            "Active Flag",
          ]
        : tableType === "bulk-upload"
          ? [
              "Row",
              "HCPEnterpriseID",
              "HCOEnterpriseID",
              "Name",
              "Operation Type",
              "Entity Type",
              "Status",
              "Errors",
            ]
          : filteredHeaders;

    // Prepare data rows
    const excelRows = filteredResults.map((result) => {
      const hasVendorKeyExp =
        Array.isArray(result.results) &&
        result.results.length > 0 &&
        "vendor" in result.results[0];
      return tableType === "bulk-search"
        ? result.type === "HCO"
          ? [
              (searchType === "basic" &&
                result.Source === "Found in EPH" &&
                result.inputEnterpriseId) ||
                "",
              result.HCOUniqueId,
              result.EntityId,
              result.Source === "Found in Vendor"
                ? result.Country
                : result.CountryCode,
              result.ClassificationCode || "",
              result?.Name || "",
              result.Specialities
                ? Array.isArray(result.Specialities)
                  ? result.Specialities.join(", ")
                  : result.Specialities
                : "",
              result.Address || "",
              result.ActiveFlag,
            ]
          : [
              (searchType === "basic" &&
                result.Source === "Found in EPH" &&
                result.inputEnterpriseId) ||
                "",
              result.HCPUniqueId,
              result.EntityId,
              result.Source === "Found in Vendor"
                ? result.Country
                : result.CountryCode,
              result.ClassificationCode || "",
              `${result.FirstName || ""} ${result.LastName || ""}`.trim(),
              result.Specialities
                ? Array.isArray(result.Specialities)
                  ? result.Specialities.join(", ")
                  : result.Specialities
                : "",
              result.Address || "",
              result.ActiveFlag,
            ]
        : tableType === "bulk-upload"
          ? [
              result.recordId || "",
              result.operationType === "CREATE" &&
              hasVendorKeyExp &&
              result?.hasShellProfile &&
              result.shellProfileResultStatus
                ? result.shellProfileResults?.HcpEnterpriseId ||
                  result?.shellProfileResults?.HCPEnterpriseId
                : result.operationType === "CREATE" &&
                    result.results &&
                    typeof result.results === "object" &&
                    !Array.isArray(result.results)
                  ? result?.results?.HcpEnterpriseId ||
                    result?.results?.HCPEnterpriseId ||
                    result?.results?.StandaloneHCPEnterpriseId
                  : result?.enterpriseId || "",
              // For HCO entity, check shell profile logic for enterprise ID if operation is CREATE and enterpriseId is empty
              result.operationType === "CREATE" &&
              hasVendorKeyExp &&
              result?.hasShellProfile &&
              result.shellProfileResultStatus
                ? result?.shellProfileResults?.HCOEnterpriseId ||
                  result?.shellProfileResults?.HcoEnterpriseId
                : result.operationType === "CREATE" &&
                    result.results &&
                    typeof result.results === "object" &&
                    !Array.isArray(result.results)
                  ? result?.results?.HCOEnterpriseId ||
                    result?.results?.HcoEnterpriseId ||
                    result?.results?.StandaloneHCOEnterpriseId
                  : result?.enterpriseId || "",
              result?.name || "",
              result.operationType || "",
              result.entityType || "",
              result.processedStatus || "",
              formatErrorMessage(result.errorMessage),
            ]
          : [
              result.fileName || "",
              result.uploadedBy || "",
              result.updatedAt || "",
              result.resultStatus || "",
            ];
    });

    // Build header + data rows for write-excel-file
    const headerRow = excelHeaders.map((header) => ({
      value: header || "",
      fontWeight: "bold",
      backgroundColor: "#FFFFFF",
    }));

    const dataRows = excelRows.map((row) =>
      row.map((value) => ({ value: value ?? "" })),
    );

    // Auto-fit column widths
    const colWidths = excelHeaders.map((header, index) => {
      let maxLength = (header || "").length;
      excelRows.forEach((row) => {
        const value = row[index];
        if (value && value.toString().length > maxLength) {
          maxLength = Math.min(value.toString().length, 50); // Cap at 50 characters
        }
      });
      return { width: Math.max(maxLength + 2, 10) };
    });

    // Generate blob and download
    const blob = await writeExcelFile([headerRow, ...dataRows], {
      sheet: "Results",
      columns: colWidths,
      stickyRowsCount: 1,
    }).toBlob();

    // Create a download link
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    let nameFile =
      tableType === "bulk-search"
        ? "bulk-search-results"
        : tableType === "bulk-upload"
          ? "bulk-upload-results"
          : "upload-history";
    link.setAttribute(
      "download",
      `${nameFile}-${new Date().toISOString().split("T")[0]}.xlsx`,
    );
    link.style.visibility = "hidden";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object
    URL.revokeObjectURL(url);
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      open: false,
      message: "",
      severity: "info",
    });
  };
  // Filter results based on status and search query
  const filteredResults = tableData.filter((result) => {
    const resultsKey =
      tableType === "bulk-search"
        ? "Source"
        : tableType === "bulk-upload"
          ? "processedStatus"
          : "resultStatus";
    // Apply status filter
    let key;
    if (result[resultsKey] === "FAILED") {
      key = result.validationStatus === "INVALID" ? "FAILEDINVALID" : "FAILED";
    }
    const statusMatch =
      statusFilter === "All" ||
      (key
        ? key.toLowerCase() === statusFilter.toLowerCase()
        : result[resultsKey].toLowerCase() === statusFilter.toLowerCase());
    // Apply search filter - search across all fields
    const searchMatch =
      searchQuery === "" ||
      Object.values(result).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase()),
      );
    return statusMatch && searchMatch;
  });

  // Apply default sorting by recordId for bulk-upload when no custom sort is active
  let resultsToSort = filteredResults;
  if (tableType === "bulk-upload" && !sortConfig.key) {
    resultsToSort = [...filteredResults].sort((a, b) => {
      const aValue = a.recordId;
      const bValue = b.recordId;

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      // Try numeric comparison first
      const aNum = Number(aValue);
      const bNum = Number(bValue);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      }

      // Fall back to string comparison
      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue);
      }

      if (aValue < bValue) return -1;
      if (aValue > bValue) return 1;
      return 0;
    });
  }

  // Apply sorting
  const sortedResults = sortData(resultsToSort);

  // Calculate paginated results
  const paginatedResults = sortedResults.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  // Custom pagination actions component
  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange } = props;
    const pageCount = Math.ceil(count / rowsPerPage);
    const handleChange = (event, value) => {
      onPageChange(event, value - 1);
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <Pagination
          count={pageCount}
          page={page + 1}
          onChange={handleChange}
          color="error"
          shape="rounded"
        />
      </Box>
    );
  };

  return (
    <div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={8000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 6 }}
        onClose={onCloseSnackbar}
      >
        <Alert
          onClose={onCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Paper
        elevation={0}
        sx={{
          border: "1px solid #d1d5db",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Box
          style={{
            padding: tableType === "bulk-search" ? "10px 24px" : "16px 24px",
          }}
          sx={{
            backgroundColor: "#f9fafb",
            px: 3,
            py: 2,
            borderBottom: "1px solid #d1d5db",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "#111827",
              fontSize: "1.125rem",
              fontWeight: 500,
            }}
          >
            Results
          </Typography>
          <CustomButton
            variant="outlined"
            size="small"
            startIcon={<DownloadIcon sx={{ fontSize: "1rem" }} />}
            onClick={exportToExcel}
            disabled={continuePolling || tableData.length === 0}
            sx={{
              px: 1,
              py: 0.5,
              backgroundColor: "white",
              fontSize: "0.875rem",
              textTransform: "none",
            }}
          >
            Export Results
          </CustomButton>
        </Box>
        <Box
          sx={{
            px: 3,
            py: 2,
            backgroundColor: "white",
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Search records…"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#9ca3af" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#d1d5db",
                },
                "&:hover fieldset": {
                  borderColor: "#9ca3af",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#D31710",
                },
              },
            }}
          />
        </Box>
        <TableContainer>
          {tableData.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 8, color: "#4A5565" }}>
              <Description sx={{ fontSize: 48, color: "#d1d5db", mb: 2 }} />
              <Typography>
                Please wait while we retrieve your results.
              </Typography>
            </Box>
          ) : (
            <Table sx={{ backgroundColor: "white" }}>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#f3f4f6",
                    borderBottom: "1px solid #d1d5db",
                  }}
                >
                  {headers.length > 0 &&
                    headers.map((header, index) => {
                      const dataKey = getDataKeyFromHeader(header);
                      const isSortable =
                        dataKey && sortableColumns.includes(dataKey);
                      const isActiveSortColumn = sortConfig.key === dataKey;

                      return (
                        <TableCell
                          key={index}
                          sx={{
                            px: index === 0 ? 3 : 2,
                            py: 2,
                            color: "#374151",
                            fontWeight: 600,
                            fontSize: "0.875rem",
                            cursor: isSortable ? "pointer" : "default",
                            userSelect: "none",
                            "&:hover": isSortable
                              ? {
                                  backgroundColor: "#e5e7eb",
                                }
                              : {},
                          }}
                          onClick={() => isSortable && handleSort(dataKey)}
                        >
                          {header === "Status" ? (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <span>{header}</span>
                              {isSortable && isActiveSortColumn && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    ml: 0.5,
                                  }}
                                >
                                  {sortConfig.direction === "asc" ? (
                                    <ArrowUpwardIcon
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#D31710",
                                      }}
                                    />
                                  ) : (
                                    <ArrowDownwardIcon
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#D31710",
                                      }}
                                    />
                                  )}
                                </Box>
                              )}
                              <FormControl
                                size="small"
                                className="filter-dropdown"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Select
                                  value={statusFilter}
                                  onChange={handleStatusFilterChange}
                                  IconComponent={() => null}
                                  renderValue={() => (
                                    <FilterAltIcon
                                      sx={{ fontSize: "1.25rem" }}
                                    />
                                  )}
                                  sx={{
                                    fontSize: "0.75rem",
                                    backgroundColor: "white",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#d1d5db",
                                    },
                                    "&:hover .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#9ca3af",
                                      },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "#d1d5db",
                                      },
                                    "& .MuiSelect-select": {
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      minWidth: "auto",
                                      padding: "2px",
                                    },
                                  }}
                                >
                                  {filters.map((filter) => (
                                    <MenuItem
                                      key={filter.value}
                                      value={filter.value}
                                      sx={{ fontSize: "0.875rem" }}
                                    >
                                      {filter.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          ) : (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <span>{header}</span>
                              {isSortable && isActiveSortColumn && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {sortConfig.direction === "asc" ? (
                                    <ArrowUpwardIcon
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#D31710",
                                      }}
                                    />
                                  ) : (
                                    <ArrowDownwardIcon
                                      sx={{
                                        fontSize: "1rem",
                                        color: "#D31710",
                                      }}
                                    />
                                  )}
                                </Box>
                              )}
                            </Box>
                          )}
                        </TableCell>
                      );
                    })}
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedResults.map((result, row) => (
                  <>
                    <TableRow
                      key={row}
                      sx={{ borderBottom: "1px solid #e5e7eb" }}
                    >
                      {tableType === "bulk-upload" ? (
                        <>
                          <TableCell sx={{ px: 3, py: 2 }}>
                            {result.recordId}
                          </TableCell>
                          <TableCell>
                            {(() => {
                              // For create operations with empty enterprise ID, check shell profile logic
                              const hasVendorKey =
                                Array.isArray(result.results) &&
                                result.results.length > 0 &&
                                "vendor" in result.results[0];

                              if (
                                result.operationType === "CREATE" &&
                                hasVendorKey
                              ) {
                                if (result?.hasShellProfile === true) {
                                  if (
                                    result.shellProfileResultStatus === true
                                  ) {
                                    // Case 1.1: Show appropriate enterprise ID based on entity type
                                    const enterpriseId =
                                      result.entityType?.toLowerCase() === "hcp"
                                        ? result?.shellProfileResults
                                            ?.HcpEnterpriseId ||
                                          result?.shellProfileResults
                                            ?.HCPEnterpriseId
                                        : result.shellProfileResults
                                            ?.HCOEnterpriseId ||
                                          result?.shellProfileResults
                                            ?.HcoEnterpriseId;
                                    return enterpriseId || "-";
                                  } else {
                                    // Case 1.2: Shell profile creation failed
                                    return (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                        }}
                                      >
                                        <span>Not Created</span>
                                        <Tooltip
                                          title="Something went wrong while creating shell profile(s). Please raise an incident to the Global DCR IT team on Service Now using the service group ENTPROFHUB-GSSIT-GLB stating the and the uploadID (sent to you via email) for further investigation."
                                          arrow
                                          componentsProps={{
                                            tooltip: {
                                              sx: {
                                                display: "-webkit-box",
                                                webkitBoxOrient: "vertical",
                                                webkitLineClamp: 2,
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "600px",
                                                fontSize: "0.75rem",
                                              },
                                            },
                                          }}
                                        >
                                          <IconButton
                                            size="small"
                                            sx={{ p: 0 }}
                                          >
                                            <ErrorOutlineIcon
                                              sx={{
                                                fontSize: "16px",
                                                color: "#D31710",
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    );
                                  }
                                } else {
                                  // Case 2: Shell profile creation disabled
                                  return (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.5,
                                      }}
                                    >
                                      <span>Not Applicable</span>
                                      {UserInfo?.isUserApprover ? (
                                        <Tooltip
                                          title="Shell profile creation in EPH is currently disabled. Please connect System Owner for more information."
                                          arrow
                                        >
                                          <InfoIcon
                                            size="small"
                                            sx={{ p: 0, fontSize: "15px" }}
                                          >
                                            <ErrorOutlineIcon
                                              sx={{
                                                fontSize: "15px",
                                                color: "#D97706",
                                              }}
                                            />
                                          </InfoIcon>
                                        </Tooltip>
                                      ) : (
                                        <Tooltip
                                          title="Shell profiles are not created for Lilly Managed DCRs."
                                          arrow
                                        >
                                          <InfoIcon
                                            size="small"
                                            sx={{ p: 0, fontSize: "15px" }}
                                          >
                                            <ErrorOutlineIcon
                                              sx={{
                                                fontSize: "15px",
                                                color: "#D97706",
                                              }}
                                            />
                                          </InfoIcon>
                                        </Tooltip>
                                      )}
                                    </Box>
                                  );
                                }
                              } else if (result.operationType === "CREATE") {
                                // Check if results object exists and has enterprise IDs
                                if (
                                  result.results &&
                                  typeof result.results === "object" &&
                                  !Array.isArray(result.results)
                                ) {
                                  // Show appropriate enterprise ID based on entity type
                                  const enterpriseId =
                                    result.entityType?.toLowerCase() === "hcp"
                                      ? result?.results?.HcpEnterpriseId ||
                                        result?.results?.HCPEnterpriseId
                                      : result.results.HCOEnterpriseId ||
                                        result?.results?.HcoEnterpriseId;
                                  return (
                                    enterpriseId || result?.enterpriseId || "-"
                                  );
                                }
                              }

                              // For update operations or when enterprise ID exists, show normal enterprise ID
                              return result?.enterpriseId || "-";
                            })()}
                          </TableCell>
                          <TableCell>{result?.name || "-"}</TableCell>
                          <TableCell>{result.operationType}</TableCell>
                          <TableCell>{result.entityType}</TableCell>
                          <TableCell>
                            {" "}
                            <Chip
                              label={
                                result.processedStatus === "PROCESSED"
                                  ? "Success"
                                  : result.processedStatus === "PENDING"
                                    ? "Pending"
                                    : result.processedStatus === "FAILED"
                                      ? result.validationStatus === "INVALID"
                                        ? "Invalid"
                                        : "Failed"
                                      : result.processedStatus
                              }
                              size="small"
                              icon={
                                result.processedStatus === "PROCESSED" ? (
                                  <CheckCircleOutlineIcon
                                    fontSize="small"
                                    color="#027A48"
                                  />
                                ) : result.processedStatus === "FAILED" ? (
                                  result.validationStatus === "INVALID" ? (
                                    <WarningAmberRoundedIcon
                                      fontSize="small"
                                      color="#D97706"
                                    />
                                  ) : (
                                    <HighlightOffIcon
                                      fontSize="small"
                                      color="#d31710"
                                    />
                                  )
                                ) : null
                              }
                              sx={{
                                backgroundColor:
                                  result.processedStatus === "PROCESSED"
                                    ? "#DCFCE7"
                                    : result.processedStatus === "FAILED"
                                      ? result.validationStatus === "INVALID"
                                        ? "#FEEBC8"
                                        : "#FEE2E2"
                                      : "#F3F4F6",
                                color:
                                  result.processedStatus === "PROCESSED"
                                    ? "#027A48"
                                    : result.processedStatus === "FAILED"
                                      ? result.validationStatus === "INVALID"
                                        ? "#D97706"
                                        : "#d31710"
                                      : "#6B7280",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box sx={{ display: "flex", gap: 1 }}>
                              {result.processedStatus === "PROCESSED" &&
                                (() => {
                                  const allDcrs = getAllDCRLinks(result);
                                  if (allDcrs.length > 0) {
                                    return (
                                      <Button
                                        onClick={() =>
                                          setDcrDialog({
                                            open: true,
                                            dcrs: allDcrs,
                                          })
                                        }
                                        variant="outlined"
                                        size="small"
                                        sx={{ textTransform: "none" }}
                                      >
                                        View DCR
                                      </Button>
                                    );
                                  } else {
                                    const ephLink = createEPHLink(
                                      getEntityId(result),
                                    );
                                    if (ephLink) {
                                      return (
                                        <Button
                                          href={ephLink}
                                          target="_blank"
                                          variant="outlined"
                                          size="small"
                                          sx={{ textTransform: "none" }}
                                        >
                                          View Profile
                                        </Button>
                                      );
                                    }
                                  }
                                })()}
                              {result.errorMessage && (
                                <Button
                                  variant="outlined"
                                  size="small"
                                  color="error"
                                  onClick={() =>
                                    setErrorDialog({
                                      open: true,
                                      errorMessage: result.errorMessage,
                                    })
                                  }
                                  sx={{ textTransform: "none" }}
                                >
                                  View Errors
                                </Button>
                              )}
                            </Box>
                          </TableCell>
                        </>
                      ) : tableType === "bulk-search" ? (
                        <>
                          <TableCell sx={{ px: 3, py: 2 }}>
                            {searchType === "basic"
                              ? result.type === "HCO"
                                ? result.Source === "Not Found"
                                  ? result.HCOUniqueId
                                  : result.Source === "Found in Vendor"
                                    ? result.HCOUniqueId
                                    : result.inputEnterpriseId
                                : result.Source === "Not Found"
                                  ? result.HCPUniqueId
                                  : result.Source === "Found in Vendor"
                                    ? result.HCPUniqueId
                                    : result.inputEnterpriseId
                              : result.type === "HCO"
                                ? result.HCOUniqueId
                                : result.HCPUniqueId}
                          </TableCell>

                          <TableCell
                            sx={{
                              px: 3,
                              py: 2,
                              maxWidth: 200,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={
                              result.Source !== "Not Found"
                                ? result.type === "HCO"
                                  ? result?.Name
                                    ? result?.Name
                                    : "-"
                                  : `${result?.FirstName ? result?.FirstName : ""} ${result?.LastName ? result?.LastName : ""}`.trim()
                                : "-"
                            }
                          >
                            {result.Source !== "Not Found"
                              ? result.type === "HCO"
                                ? result?.Name
                                  ? result?.Name
                                  : "-"
                                : result?.FirstName || result?.LastName
                                  ? `${result?.FirstName ? result?.FirstName : ""} ${result?.LastName ? result?.LastName : ""}`.trim()
                                  : "-"
                              : "-"}
                          </TableCell>

                          <TableCell sx={{ px: 3, py: 2 }}>
                            {result.type === "HCO"
                              ? result.Source === "Found in Vendor"
                                ? result.Country
                                : result.CountryCode
                              : result.Source === "Found in Vendor"
                                ? result.Country
                                : result.CountryCode}
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Chip
                              label={result.Source}
                              size="small"
                              sx={{
                                backgroundColor:
                                  result.Source === "Found in EPH"
                                    ? "#DCFCE7"
                                    : result.Source === "Found in Vendor"
                                      ? "#DBEAFE"
                                      : "#FEE2E2",
                                color:
                                  result.Source === "Found in EPH"
                                    ? "#027A48"
                                    : result.Source === "Found in Vendor"
                                      ? "#1447E6"
                                      : "#d31710",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              <Button
                                variant="outlined"
                                startIcon={
                                  result.Source === "Found in Vendor" ? (
                                    <DownloadIcon fontSize="small" />
                                  ) : result.Source === "Not Found" ? (
                                    <AddIcon fontSize="small" />
                                  ) : result.Source === "Found in EPH" ? (
                                    checkingProfileId === result.EntityId ? (
                                      ""
                                    ) : (
                                      <EditNoteIcon fontSize="small" />
                                    )
                                  ) : null
                                }
                                color={
                                  result.Source === "Found in EPH"
                                    ? "success"
                                    : result.Source === "Found in Vendor"
                                      ? "primary"
                                      : "error"
                                }
                                disabled={checkingProfileId === result.EntityId}
                                sx={{
                                  padding: "4px 10px",
                                  fontSize: "0.875rem",
                                }}
                                onClick={() => {
                                  if (result.Source === "Found in Vendor") {
                                    handleDownload(result);
                                  } else if (result.Source === "Found in EPH") {
                                    handleCheckProfile(result);
                                  } else if (result.Source === "Not Found") {
                                    if (result.type === "HCP") {
                                      history.push("/new/hcp", {
                                        user: UserInfo,
                                        iqviaSource: false,
                                        homePage_Lilly: false,
                                      });
                                    } else {
                                      history.push("/new/hco", {
                                        user: UserInfo,
                                        iqviaSource: false,
                                        homePage_Lilly: false,
                                      });
                                    }
                                  }
                                }}
                              >
                                {checkingProfileId === result.EntityId ? (
                                  <CircularProgress
                                    size={20}
                                    style={{ color: "#4caf50" }}
                                  />
                                ) : result.Source === "Found in Vendor" ? (
                                  "Download"
                                ) : result.Source === "Not Found" ? (
                                  "Create Profile"
                                ) : result.Source === "Found in EPH" ? (
                                  "DCR"
                                ) : null}
                              </Button>
                              {(result.Source === "Found in EPH" ||
                                result.Source === "Found in Vendor") && (
                                <VisibilityIcon
                                  size="small"
                                  style={{
                                    cursor: "pointer",
                                    color: "rgb(211, 47, 47)",
                                  }}
                                  onClick={() => handleViewDetails(row)}
                                />
                              )}
                            </Box>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell sx={{ px: 3, py: 2 }}>
                            {" "}
                            <Tooltip title={result.fileName} arrow>
                              <Link
                                component="button"
                                style={{
                                  textDecoration: "none",
                                  maxWidth: "250px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  display: "block",
                                }}
                                variant="body2"
                                onClick={(e) =>
                                  handleClickHistory(
                                    result?.searchScope,
                                    result?.uploadId,
                                    result?.appId,
                                    result?.totalRecordsUploaded,
                                    result?.searchType,
                                    result?.createdAt,
                                    result?.eConsentCountry,
                                    result?.resultStatus,
                                  )
                                }
                              >
                                {result.fileName}
                              </Link>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={result?.uploadId || "-"}
                              size="small"
                              sx={{
                                backgroundColor: "#EEF2FF",
                                color: "#3730A3",
                                fontWeight: 500,
                              }}
                            />
                          </TableCell>

                          <TableCell>{result.uploadedBy}</TableCell>
                          <TableCell>
                            {result.createdAt?.split(".")[0]} (UTC)
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Chip
                              label={
                                result.resultStatus.toLowerCase() === "failed"
                                  ? "Failed"
                                  : result.resultStatus.toLowerCase() ===
                                      "completed"
                                    ? "Success"
                                    : result.resultStatus.toLowerCase() ===
                                        "pending"
                                      ? "Pending"
                                      : result.resultStatus === "REVIEW_PENDING"
                                        ? "Review Pending"
                                        : result.resultStatus ===
                                            "REVIEW_SUBMITTED"
                                          ? "Review Submitted"
                                          : result.resultStatus
                              }
                              size="small"
                              icon={
                                result.resultStatus.toLowerCase() ===
                                  "completed" ||
                                result.resultStatus === "REVIEW_SUBMITTED" ? (
                                  <CheckCircleOutlineIcon
                                    fontSize="small"
                                    color="#027A48"
                                  />
                                ) : result.resultStatus.toLowerCase() ===
                                  "failed" ? (
                                  <HighlightOffIcon
                                    fontSize="small"
                                    color="#d31710"
                                  />
                                ) : result.resultStatus.toLowerCase() ===
                                    "pending" ||
                                  result.resultStatus === "REVIEW_PENDING" ? (
                                  <ScheduleIcon
                                    fontSize="small"
                                    color="#D97706"
                                  />
                                ) : null
                              }
                              sx={{
                                backgroundColor:
                                  result.resultStatus.toLowerCase() ===
                                    "completed" ||
                                  result.resultStatus === "REVIEW_SUBMITTED"
                                    ? "#DCFCE7"
                                    : result.resultStatus.toLowerCase() ===
                                          "pending" ||
                                        result.resultStatus === "REVIEW_PENDING"
                                      ? "#FEEBC8"
                                      : "#FEE2E2",
                                color:
                                  result.resultStatus.toLowerCase() ===
                                    "completed" ||
                                  result.resultStatus === "REVIEW_SUBMITTED"
                                    ? "#027A48"
                                    : result.resultStatus.toLowerCase() ===
                                          "pending" ||
                                        result.resultStatus === "REVIEW_PENDING"
                                      ? "#D97706"
                                      : "#d31710",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            {" "}
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              {!(
                                tableType === "upload-history" &&
                                result?.appId === "BULKUPLOAD" &&
                                result?.resultStatus !== "COMPLETED"
                              ) && (
                                <Button
                                  variant="outlined"
                                  startIcon={
                                    downloadingHistoryId === result?.uploadId ? (
                                      ""
                                    ) : (
                                      <DownloadIcon fontSize="small" />
                                    )
                                  }
                                  color={"error"}
                                  onClick={(e) =>
                                    handleDownloadHistory(
                                      result?.uploadId,
                                      result?.appId,
                                      result?.createdAt,
                                      result?.searchType,
                                      result?.fileName,
                                    )
                                  }
                                  disabled={
                                    result.resultPath === "FALSE" ||
                                    downloadingHistoryId === result?.uploadId
                                  }
                                  sx={{
                                    padding: "4px 10px",
                                    textTransform: "none",
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  {downloadingHistoryId === result?.uploadId ? (
                                    <CircularProgress
                                      size={26}
                                      style={{ color: "rgb(211, 47, 47)" }}
                                    />
                                  ) : (
                                    "Download"
                                  )}
                                </Button>
                              )}
                            </Box>
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                    {expandedRow === row && (
                      <AccordianDetails result={result} />
                    )}
                  </>
                ))}
              </TableBody>
            </Table>
          )}
        </TableContainer>
        <TablePagination
          count={sortedResults.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[25, 50, 75, 100]}
          ActionsComponent={TablePaginationActions}
          labelDisplayedRows={({ from, to, count }) =>
            `Showing ${from}-${to} of ${count} results`
          }
          labelRowsPerPage="Rows per page:"
          sx={{
            display: "flex",
            justifyContent: "end",
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              px: 2,
              py: 1,
            },
            "& .MuiTablePagination-displayedRows": {
              margin: 0,
              fontSize: "0.875rem",
              color: "#374151",
            },
            "& .MuiTablePagination-selectLabel": {
              margin: 0,
              fontSize: "0.875rem",
              color: "#374151",
            },
            "& .MuiTablePagination-select": {
              fontSize: "0.875rem",
            },
          }}
        />
      </Paper>
      {userProfile && (
        <NotFoundPopup
          open={userProfile}
          entityId={entityId}
          onClose={() => setUserProfile(false)}
        />
      )}
      <Dialog
        open={errorDialog.open}
        onClose={() => setErrorDialog({ open: false, errorMessage: "" })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ display: "flex", alignItems: "center", gap: 1 }}
          >
            <ErrorOutlineIcon sx={{ color: "#d31710" }} />
            Error Details
          </Typography>
          <IconButton
            onClick={() => setErrorDialog({ open: false, errorMessage: "" })}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            component="ul"
            sx={{
              pl: 2,
              mb: 0,
              mt: 0,
              listStyleType: "disc",
              color: "#d31710",
            }}
          >
            {errorDialog.errorMessage
              .split(/\n+/)
              .filter(Boolean)
              .map((line, idx) => {
                const trimmedLine = line.trim();
                const lineWithPeriod = trimmedLine.endsWith(".")
                  ? trimmedLine
                  : `${trimmedLine}.`;
                return <li key={idx}>{lineWithPeriod}</li>;
              })}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setErrorDialog({ open: false, errorMessage: "" })}
            variant="contained"
            sx={{
              backgroundColor: "#D31710",
              "&:hover": {
                backgroundColor: "#B01309",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dcrDialog.open}
        onClose={() => setDcrDialog({ open: false, dcrs: [] })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">DCR Links</Typography>
          <IconButton
            onClick={() => setDcrDialog({ open: false, dcrs: [] })}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {dcrDialog.dcrs.map((dcr, idx) => (
              <Paper
                key={idx}
                elevation={1}
                sx={{
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                  border: "1px solid #e5e7eb",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#374151" }}
                  >
                    DCR ID:
                  </Typography>
                  <Link
                    href={dcr.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#D31710",
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {dcr.id}
                  </Link>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#374151" }}
                  >
                    Vendor:
                  </Typography>
                  <Chip
                    label={dcr.vendor}
                    size="small"
                    sx={{
                      backgroundColor: "#f3f4f6",
                      color: "#374151",
                    }}
                  />
                </Box>
              </Paper>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setDcrDialog({ open: false, dcrs: [] })}
            variant="contained"
            sx={{
              backgroundColor: "#D31710",
              "&:hover": {
                backgroundColor: "#B01309",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ResultsTable;